@if (addressId$ | async) {
<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="recManagementForm">
    <div class="recording-management onsip-grid-placement">
      <div class="first-column">
        <div class="m-b-12">
          <div class="mat-body-1 m-b-8">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
          <onsip-sip-address-field formControlName="sipAddress"> </onsip-sip-address-field>
        </div>
        <div class="m-b-12">
          <div class="mat-body-1 m-b-8">{{ "ONSIP_I18N.PIN" | translate }}</div>
          <div class="onsip-grid-placement pin-field-wrapper">
            <mat-form-field appearance="outline" class="pin-field">
              <input matInput formControlName="pin" autocomplete="off" />
              <mat-error>
                {{ getGenericError(recManagementForm.controls.pin, "ONSIP_I18N.PIN" | translate) }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="second-column">
        <div class="m-b-28">
          <div class="mat-body-1 m-b-8">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #extensionsList
            [currentId]="(addressId$ | async)!"
            formControlName="extensions"
          >
          </onsip-extensions-list>
        </div>
      </div>
      <div class="actions">
        <button mat-button color="primary" class="cancel-btn" type="button" (click)="cancel()">
          {{ "ONSIP_I18N.CANCEL" | translate }}
        </button>
        <button
          mat-flat-button
          type="submit"
          class="toggle-button"
          color="primary"
          (click)="saveForm()"
        >
          {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
        </button>
      </div>
    </div>
  </form>
</onsip-loading-container>
}
